// extracted by mini-css-extract-plugin
export default {"floatinglabelinput":"TextInput_floatinglabelinput__6Rbvz","filledlabel":"TextInput_filledlabel__BWdg4"};